import React, { useEffect, useState } from 'react';
import styles from "./orders.module.css"
import ProfileMenu from '../../components/profilemenu/ProfileMenu';
import Orderbody from '../../components/orderbody/Orderbody';
import Myprofile from '../myprofile/Myprofile';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrdersThunk } from '../../../redux/orderSlice';
 
const Orders = () => {

    const dispatch = useDispatch();
    const [sort, setSort] = useState('newest');
 
    useEffect(()=>{
        dispatch(getAllOrdersThunk({ page: 1, size: 10, sort }));
    }, [dispatch, sort]);


    return (
        <Myprofile>
      
            <Orderbody sort={sort} setSort={setSort} />

        </Myprofile>
    );
};

export default Orders;
